import { render, staticRenderFns } from "./FormOptionCardElement.vue?vue&type=template&id=fa445810&scoped=true"
import script from "./FormOptionCardElement.vue?vue&type=script&lang=js"
export * from "./FormOptionCardElement.vue?vue&type=script&lang=js"
import style0 from "./FormOptionCardElement.vue?vue&type=style&index=0&id=fa445810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa445810",
  null
  
)

export default component.exports